var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_679_81246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0002 93.729C124.039 93.729 159.739 87.5822 159.739 79.9997C159.739 72.4173 124.039 66.2705 80.0002 66.2705C35.9619 66.2705 0.261719 72.4173 0.261719 79.9997C0.261719 87.5822 35.9619 93.729 80.0002 93.729Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.96 144.385C125.96 148.515 105.377 151.871 79.9993 151.871C54.622 151.871 34.0391 148.515 34.0391 144.385C34.0391 140.256 54.6111 136.911 79.9993 136.911C105.387 136.911 125.96 140.256 125.96 144.385Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0008 128.488C118.719 128.488 150.107 123.38 150.107 117.08C150.107 110.779 118.719 105.671 80.0008 105.671C41.2822 105.671 9.89453 110.779 9.89453 117.08C9.89453 123.38 41.2822 128.488 80.0008 128.488Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9993 23.078C105.382 23.078 125.96 19.7314 125.96 15.6032C125.96 11.475 105.382 8.12842 79.9993 8.12842C54.6162 8.12842 34.0391 11.475 34.0391 15.6032C34.0391 19.7314 54.6162 23.078 79.9993 23.078Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0008 54.3284C118.719 54.3284 150.107 49.2207 150.107 42.9201C150.107 36.6194 118.719 31.5117 80.0008 31.5117C41.2822 31.5117 9.89453 36.6194 9.89453 42.9201C9.89453 49.2207 41.2822 54.3284 80.0008 54.3284Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_81246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.ecfb4a5870328012ae61d18b6b976807.svg";
export { ForwardRef as ReactComponent };